<template>
  <tabs @TabChange="onTabChange" centered position="bottom" type="neutral" tab-nav-wrapper-classes="card-header-nav icon" tab-content-classes="tab-content-padding tab-no-space " v-model="activeTab">

    <tab-pane label="add-credit-points">
      <template slot="label">
        <i class="fas fa-plus"></i>
      </template>
      <div class="credit-request">
        <credit-request-svg style="position: fixed; bottom: 4em;width:90%; max-height: 40vh;left: 50%; transform: translateX(-50%)"></credit-request-svg>

        <div style="margin: 1em; text-align: center;">
          <div style="font-size: 0.7em; color: ">
            <span>{{ $t('message.Credits available')}}</span>
          </div>
          <div style="font-size: 3em; font-weight: bolder; color:var(--success);">
            <span>
              <i class="fas fa-coins" style="font-size: 0.7em; color:var(--color-primary);"></i>
              {{userDetails.credits}}
            </span>
          </div>
          <span v-if="userDetails.credits<500" style="font-size: 0.6em; color: var(--danger)"> <i class="fas fa-exclamation-circle"></i> {{$t('message.Credits too low Please refill')}}</span>
        </div>

        <div class="button-container">
          <h6>{{$t('message.Refill Credits')}}</h6>
          <n-button type="primary" size="lg" round wide @click.native="SHOW_GET_CREDIT_ONLINE_MODAL = true">{{ $t('message.Online') }}</n-button>
          <n-button type="primary" size="lg" round wide simple @click.native="SHOW_CREDIT_REQUEST_MODAL = true">{{$t('message.Offline')}}</n-button>
        </div>

        <modal :show.sync="SHOW_CREDIT_REQUEST_MODAL" v-if="SHOW_CREDIT_REQUEST_MODAL" footer-classes="justify-content-center">
          <div slot="header" style="margin-top:2em;">
            <h5 class="title title-up">{{ $t('message.Transaction details') }}</h5>
          </div>
          <div class="row">
            <fg-input class="col-sm-6 col-12" :label="$t('message.Transaction ID')" name='creditRequestTransactionId' v-model="transactionId" v-validate="modelValidations.transactionId" :placeholder="$t('message.Transaction ID')" :error="getError('creditRequestTransactionId')">
            </fg-input>
          </div>
          <div class="row">
            <fg-input class="col-sm-6 col-12" :label="$t('message.Amount')" v-model="amount" name='creditRequestAmount' v-validate="modelValidations.amount" :placeholder="$t('message.Amount')" :error="getError('creditRequestAmount')" type="Number">
            </fg-input>
          </div>
          <div slot="footer">
            <n-button type="primary" round @click.native="validateCreditRequest">{{$t('message.Request')}}</n-button>
          </div>
        </modal>

        <modal :show.sync="SHOW_GET_CREDIT_ONLINE_MODAL" v-if="SHOW_GET_CREDIT_ONLINE_MODAL" footer-classes="justify-content-center">
          <div slot="header" style="margin-top:2em;">
            <h6 class="title title-up">{{ $t('message.Refill Credits') }}</h6>
          </div>
          <div class="row">
            <fg-input class="col-sm-6 col-12" :label="$t('message.Number of credit points')" v-model="amount" name='creditRequestAmount' v-validate="modelValidations.amount" :placeholder="$t('message.Number of credit points')" :error="getError('creditRequestAmount')" type="Number" @keypress="restrictToTwoDecimalPlaces">
            </fg-input>
          </div>
          <div style="width: 100%;" slot="footer">
            <div style="width: fit-content; margin: auto;">
              <n-button style="text-transform: uppercase;" type="primary" round @click.native="validateTransaction">{{$t('message.REFILL')}}</n-button>
            </div>
            <div class="row" style="margin-bottom: -0.8em;">
              <span style="font-size: 0.8em;"> {{ $t('message.1 Rupee = 1 Credit point')}}</span>
            </div>
          </div>
        </modal>
      </div>
    </tab-pane>

    <tab-pane label="credit-requests">
      <template slot="label">
        <i class="fas fa-bars"></i>
      </template>

      <tabs type="primary" centered class="credit-points-history-tabs" tab-nav-wrapper-classes="p-0" style="padding-top:1em;">
        <tab-pane label="offline-requests">
          <template slot="label">
            <span>{{ $t("message.Offline") }}</span>
          </template>
          <div style="align-items: center" class="credit-request pl-3 pr-3">
            <div class="row" style="width: 100%; margin: auto;" v-for="creditRequest in creditRequests" :key="creditRequest._id">
              <div class="pr-1 col-12 autocomplete-result">
                <div class="row">
                  <!-- credit request status icons -->
                  <div class="col-2" style="display: flex; align-items: center; font-weight: 700;font-size: 2em">
                    <div v-if="creditRequest.latestStatus == 'Requested'">
                      <i class="fas fa-circle-notch fa-spin text-info"></i>
                    </div>
                    <div v-if="creditRequest.latestStatus == 'Credited'">
                      <i class="fas fa-check-circle text-success"></i>
                    </div>
                    <div v-if="creditRequest.latestStatus == 'Declined'">
                      <i class="fas fa-times-circle text-danger"></i>
                    </div>
                  </div>

                  <div class="col-7">
                    <h6 class="item-name" style="text-transform:none; margin-bottom: 0;">
                      #{{ creditRequest.transactionId }}
                    </h6>
                    <div style="font-size: 0.8em; margin-bottom: 0.5rem;">
                      <div v-if="creditRequest.latestStatus == 'Requested'">
                        <span class="text-info">{{$t('message.Requested')}}</span>
                      </div>
                      <div v-if="creditRequest.latestStatus == 'Credited'">
                        <span class="text-success">{{$t('message.Credited')}}</span>
                      </div>
                      <div v-if="creditRequest.latestStatus == 'Declined'">
                        <span class=" text-danger">{{$t('message.Declined')}}</span>
                      </div>
                    </div>
                    <div>
                      <span> {{ getFormattedDate(creditRequest.requestedOn)}} </span>
                    </div>
                  </div>

                  <div class="col-3" style="display: flex; align-items: center; justify-content: flex-end; font-weight: 700;">
                    {{creditRequest.amount}}
                    <i class="ml-1 fas fa-coins"></i>
                  </div>
                </div>
              </div>
              <hr>
            </div>
            <infinite-loading spinner="waveDots" @infinite="getCreditRequests">
              <span slot="no-more">{{ $t('message.No more credit requests') }}</span>
              <span slot="no-results"></span>
            </infinite-loading>
          </div>
        </tab-pane>

        <tab-pane label="online-requests">
          <template slot="label">
            <span>{{ $t("message.Online") }}</span>
          </template>
          <div style="align-items: center" class="credit-request pl-3 pr-3">
            <div class="row" style="width: 100%; margin: auto;" v-for="transaction in onlineCreditTransactions" :key="transaction._id">
              <div class="pr-1 col-12 autocomplete-result">
                <div class="row">
                  <!-- credit request status icons -->
                  <div class="col-2" style="display: flex; align-items: center; font-weight: 700;font-size: 2em">
                    <div v-if="transaction.latestStatus == 'Initiated'">
                      <i class="fas fa-circle-notch fa-spin text-info"></i>
                    </div>
                    <div v-if="transaction.latestStatus == 'Success'">
                      <i class="fas fa-check-circle text-success"></i>
                    </div>
                    <div v-if="transaction.latestStatus == 'Failed'">
                      <i class="fas fa-times-circle text-danger"></i>
                    </div>
                  </div>

                  <div class="col-7">
                    <h6 class="item-name" style="text-transform:none; margin-bottom: 0;">
                      {{ transactionReference(transaction) }}
                    </h6>

                    <div style="font-size: 0.8em; margin-bottom: 0.5rem;">
                      <div v-if="transaction.latestStatus == 'Initiated'">
                        <span class="text-info">{{$t('message.Pending')}}</span>
                      </div>
                      <div v-if="transaction.latestStatus == 'Success'">
                        <span class="text-success">{{$t('message.Credited')}}</span>
                      </div>
                      <div v-if="transaction.latestStatus == 'Failed'">
                        <span class=" text-danger">{{$t('message.Failed')}}</span>
                      </div>
                    </div>

                    <div>
                      <span> {{ getFormattedDate(transaction.created)}} </span>
                    </div>
                  </div>

                  <div class="col-3" style="display: flex; align-items: center; justify-content: flex-end; font-weight: 700;">
                    {{transaction.paymentDetails.amount}}
                    <i class="ml-1 fas fa-coins"></i>
                  </div>
                </div>
              </div>
              <hr>
            </div>
            <infinite-loading spinner="waveDots" @infinite="getOnlineCreditTransactions">
              <span slot="no-more">{{ $t('message.No more transactions') }}</span>
              <span slot="no-results"></span>
            </infinite-loading>
          </div>
        </tab-pane>
      </tabs>

    </tab-pane>

  </tabs>
</template>

<script>
import { TabPane, Tabs } from "src/components";
import CreditRequestSvg from "src/pages/carenation/components/svg_images/CreditsRequestSvg.vue";
import { AllInOneSDK } from "@ionic-native/all-in-one-sdk/ngx";

export default {
  components: {
    TabPane,
    Tabs,
    CreditRequestSvg,
  },

  data() {
    return {
      transactionId: null,
      amount: null,
      modal: false,
      SHOW_CREDIT_REQUEST_MODAL: false,
      SHOW_GET_CREDIT_ONLINE_MODAL: false,
      activeTab: "add-credit-points",
      creditRequests: null,
      onlineCreditTransactions: null,
      creditRequestsPagination: {
        pageNumber: 1,
        totalPages: 0,
        pageSize: 10,
      },
      onlineCreditTransactionsPagination: {
        pageNumber: 1,
        totalPages: 0,
        pageSize: 10,
      },
      gettingCreditRequests: false,
      gettingOnlineCreditTransactions: false,
      loader: null,
      modelValidations: {
        transactionId: {
          required: true,
        },
        amount: {
          required: true,
        },
      },
    };
  },

  async mounted() {
    this.loader = this.$loading.show({
      container: null,
      canCancel: false,
    });
    this.changeAppHeaderText("add-credit-points");
    try {
      await this.$store.dispatch("getUserDetails", this.user._id);
    } catch (error) {
      console.error(error);
    }
    await this.getCreditRequests();
    await this.getOnlineCreditTransactions();
    this.loader.hide();
    this.loader = null;
  },

  methods: {
    restrictToTwoDecimalPlaces($event) {
      // console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      // only allow number and one dot
      if (
        (keyCode < 48 || keyCode > 57) &&
        (keyCode !== 46 || this.amount.indexOf(".") != -1)
      ) {
        // 46 is dot
        $event.preventDefault();
      }

      // restrict to 2 decimal places
      if (
        this.amount != null &&
        this.amount.indexOf(".") > -1 &&
        this.amount.split(".")[1].length > 1
      ) {
        $event.preventDefault();
      }
    },

    async getCreditRequests($state) {
      try {
        if (!this.gettingCreditRequests) {
          this.gettingCreditRequests = true;

          if (!$state) {
            this.creditRequests = [];
            this.creditRequestsPagination = {
              pageNumber: 1,
              totalPages: 0,
              pageSize: 10,
            };
          }
          let response = await this.$store.dispatch("getCreditRequests", {
            pageNumber: this.creditRequestsPagination.pageNumber,
            pageSize: this.creditRequestsPagination.pageSize,
          });
          if (response && response.data && response.data.length) {
            response.data.forEach((data) => {
              let exists = this.creditRequests.some((request) => {
                return request._id == data._id;
              });
              if (!exists) {
                this.creditRequests.push(data);
              }
            });
            this.creditRequestsPagination.totalPages = response.totalPages;
            this.creditRequestsPagination.pageNumber += 1;
            $state && $state.loaded();
          } else {
            $state && $state.complete();
          }
          this.gettingCreditRequests = false;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async getOnlineCreditTransactions($state) {
      try {
        if (!this.gettingOnlineCreditTransactions) {
          this.gettingOnlineCreditTransactions = true;

          if (!$state) {
            this.onlineCreditTransactions = [];
            this.onlineCreditTransactionsPagination = {
              pageNumber: 1,
              totalPages: 0,
              pageSize: 10,
            };
          }
          let response = await this.$store.dispatch(
            "getOnlineCreditTransactions",
            {
              pageNumber: this.onlineCreditTransactionsPagination.pageNumber,
              pageSize: this.onlineCreditTransactionsPagination.pageSize,
            }
          );
          if (response && response.data && response.data.length) {
            response.data.forEach((data) => {
              let exists = this.onlineCreditTransactions.some((request) => {
                return request._id == data._id;
              });
              if (!exists) {
                this.onlineCreditTransactions.push(data);
              }
            });
            this.onlineCreditTransactionsPagination.totalPages =
              response.totalPages;
            this.onlineCreditTransactionsPagination.pageNumber += 1;
            $state && $state.loaded();
          } else {
            $state && $state.complete();
          }
          this.gettingOnlineCreditTransactions = false;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async requestCredit() {
      this.loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      try {
        //backend call
        let response = await this.$store.dispatch("requestCredits", {
          transactionId: this.transactionId,
          amount: this.amount,
        });
        //on success
        this.SHOW_CREDIT_REQUEST_MODAL = false;
        if (response) {
          swal.fire({
            type: "success",
            title: this.$t("message.Credits requested"),
            timer: 3000,
          });
          this.transactionId = "";
          this.amount = null;
          this.getCreditRequests();
          this.loader.hide();
          this.loader = null;
        }
      } catch (error) {
        this.loader.hide();
        this.loader = null;
        swal.fire({
          type: "error",
          title: this.$t("message.Unable request credits"),
          timer: 3000,
        });
      }
    },

    initiatePayment() {
      if (
        this.settings.paymentSettings.razorpay.enabled &&
        this.settings.paymentPreferences.creditRefills.razorpay.enabled &&
        RazorpayCheckout
      ) {
        this.initiateRazorPayPayment();
      } else if (
        this.settings.paymentSettings.paytm.enabled &&
        this.settings.paymentPreferences.creditRefills.paytm.enabled
      ) {
        this.initiatePaytmPayment();
      } else {
        swal.fire(this.$t("message.Error with payment method"));
      }
      this.SHOW_GET_CREDIT_ONLINE_MODAL = false;
    },

    async initiateRazorPayPayment() {
      let that = this;
      this.PAYMENT_INPROGRESS = true;
      that.loader = this.$loading.show({
        // Optional parameters
        container: null,
        canCancel: false,
      });

      let transaction;
      try {
        transaction = await this.$store.dispatch(
          "initiateCreditPointsPayment",
          {
            gateway: "razorpay",
            nurse: {
              userId: this.user._id,
              address: this.user.address,
              mobileNumber: this.user.mobileNumber,
              firstName: this.user.firstName,
              lastName: this.user.lastName,
              email: this.user.email,
            },
            amount: this.amount,
            currency: "INR",
          }
        );
      } catch (error) {
        console.log(error);
      }

      var options = {
        order_id: transaction.paymentDetails.orderId,
        description: this.settings.paymentSettings.razorpay.paymentDescription,
        key: this.settings.paymentSettings.razorpay.key_id,
        currency: transaction.paymentDetails.currency,
        amount: Number(transaction.paymentDetails.amount) * 100 + "",
        name: this.settings.paymentSettings.razorpay.name,
        image: "https://i.imgur.com/n5tjHFD.png",
        prefill: {
          name: this.user.firstName + " " + this.user.lastName,
          email:
            this.user.email || this.settings.directBookings.defaultEmail || "",
          contact: this.user.mobileNumber,
        },
        theme: {
          color:
            document.documentElement.style.getPropertyValue(
              "--color-primary"
            ) || "#f96332",
        },
      };

      if (this.settings.paymentSettings.razorpay.logoUrl) {
        options.image = this.settings.paymentSettings.razorpay.logoUrl;
      }

      window.razorpaySuccessCallback = async function (response) {
        response.amount = that.amount;
        response.currency = that.currency;
        response.userId = that.user._id;
        response.razorpay_order_id = transaction.paymentDetails.orderId;
        try {
          let verificationResponse = await that.$store.dispatch(
            "verifyCreditPointsPayment",
            {
              gateway: "razorpay",
              transaction: response,
            }
          );

          if (
            verificationResponse &&
            verificationResponse.latestStatus == "Success"
          ) {
            try {
              await that.$store.dispatch("getUserDetails", that.user._id);
            } catch (error) {
              console.error(error);
            }
            //credits are updated after success in backend
            that.loader.hide();
            swal.fire({
              type: "success",
              title: that.$t("message.Credits added successfully"),
              html:
                '<div class="row" style="margin-top: 1em;">' +
                '<div class="col-6" style="border-right: 1px solid #ccc;">' +
                '<h6 style="font-size: 0.7em;">' +
                that.$t("message.Credits added") +
                "</h6>" +
                '<span style="font-size: 2em; font-weight:600;">' +
                that.amount +
                "</span>" +
                "</div>" +
                '<div class="col-6">' +
                '<h6 style="font-size: 0.7em;">' +
                that.$t("message.Current balance") +
                "</h6>" +
                '<span style="font-size: 2em; font-weight:600;">' +
                that.userDetails.credits +
                "</span>" +
                "</div>" +
                "</div>",
            });
          } else {
            that.loader.hide();
            throw new Error("Payment failed");
          }
        } catch (e) {
          console.log(e);
          that.loader.hide();
          swal.fire({
            type: "error",
            title: that.$t("message.Payment failed!"),
            timer: 5000,
          });
        }
      };

      window.razorpayCancelCallback = function (error) {
        console.log(error);
        swal.fire({
          type: "error",
          title: that.$t("message.Payment failed!"),
          timer: 5000,
        });
      };

      RazorpayCheckout.on("payment.success", window.razorpaySuccessCallback);
      RazorpayCheckout.on("payment.cancel", window.razorpaySuccessCallback);
      RazorpayCheckout.open(options);
    },

    async initiatePaytmPayment() {
      let that = this;
      this.PAYMENT_INPROGRESS = true;
      that.loader = this.$loading.show({
        // Optional parameters
        container: null,
        canCancel: false,
      });

      let allInOneSDK = new AllInOneSDK();

      //Call Initiate Transaction API from your backend to generate Transaction Token.
      let transaction = await this.$store.dispatch(
        "initiateCreditPointsPayment",
        {
          gateway: "paytm",
          nurse: {
            userId: this.user._id,
            address: this.user.address,
            mobileNumber: this.user.mobileNumber,
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            email: this.user.email,
          },
          amount: this.amount,
          currency: "INR",
          //send resposnse from the above step
        }
      );

      let isStaging =
        that.settings.paymentSettings.paytm.callbackUrl.includes("stage");

      // constructor(private allInOneSDK : AllInOneSDK) {}
      let paymentIntent = {
        mid: that.settings.paymentSettings.paytm.mid,
        orderId: transaction.paymentDetails.orderId,
        txnToken: transaction.paymentDetails.txnToken, //"<Transaction Token generated by Initiate Transaction API from your backend>",
        amount: transaction.paymentDetails.amount,
        isStaging: isStaging, //needs to come from settings
        callbackUrl:
          that.settings.paymentSettings.paytm.callbackUrl +
          "?ORDER_ID=" +
          transaction.paymentDetails.orderId,
        restrictAppInvoke: isStaging,
        enableAssist: true,
      };

      allInOneSDK
        .startTransaction(paymentIntent)
        .then(async (resp) => {
          // The response received after the transaction is completed will be an object containing "message" and "response". You can parse both and use them as required in your application
          let response = JSON.parse(resp.response);

          if (response.STATUS == "TXN_SUCCESS") {
            try {
              response.amount = that.amount;
              response.currency = that.currency;
              response.userId = that.user._id;
              response.razorpay_order_id = transaction.paymentDetails.orderId;
              response.transactionId = transaction._id;
              let verificationResponse = await that.$store.dispatch(
                "verifyCreditPointsPayment",
                {
                  gateway: "paytm",
                  transaction: response,
                }
              );
              if (
                verificationResponse &&
                verificationResponse.latestStatus == "Success"
              ) {
                try {
                  await that.$store.dispatch("getUserDetails", that.user._id);
                } catch (error) {
                  console.error(error);
                }
                //credits are updated after success in backend
                swal.fire({
                  type: "success",
                  title: that.$t("message.Credits added successfully"),
                  html:
                    '<div class="row" style="margin-top: 1em;">' +
                    '<div class="col-6" style="border-right: 1px solid #ccc;">' +
                    '<h6 style="font-size: 0.7em;">' +
                    that.$t("message.Credits added") +
                    "</h6>" +
                    '<span style="font-size: 2em; font-weight:600;">' +
                    that.amount +
                    "</span>" +
                    "</div>" +
                    '<div class="col-6">' +
                    '<h6 style="font-size: 0.7em;">' +
                    that.$t("message.Current balance") +
                    "</h6>" +
                    '<span style="font-size: 2em; font-weight:600;">' +
                    that.userDetails.credits +
                    "</span>" +
                    "</div>" +
                    "</div>",
                });
              } else {
                that.PAYMENT_INPROGRESS = false;
                throw new Error("Error getting the user");
              }
            } catch (error) {
              console.error(error);
              throw new Error("Payment failed");
            }
          } else {
            // createappointment28
            that.PAYMENT_INPROGRESS = false;
            throw new Error("Payment failed");
          }
        })
        .catch((error) => {
          // alert(error);
          console.error(error);
          swal.fire({
            type: "error",
            title: that.$t("message.Payment failed!"),
            timer: 5000,
          });
        });
      that.loader.hide();
    },

    onTabChange(label) {
      this.activeTab = label;
      this.changeAppHeaderText(label);
      this.$forceUpdate();
    },

    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validateTransaction() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.initiatePayment();
        }
      });
    },

    validateCreditRequest() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.requestCredit();
        }
      });
    },

    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY, hh:mm a");
    },

    transactionReference(transaction) {
      if (transaction && transaction.paymentGateway == "razorpay") {
        var paymentMode;
        if (transaction.gatewayResponse) {
          paymentMode = transaction.gatewayResponse.method;
        }
        var transactionReference;
        if (
          transaction &&
          transaction.gatewayResponse &&
          transaction.gatewayResponse.method &&
          transaction.gatewayResponse.acquirer_data
        ) {
          switch (paymentMode) {
            case "netbanking":
              transactionReference =
                "#" +
                  transaction.gatewayResponse.acquirer_data
                    .bank_transaction_id || "N/A"; //bank_transaction_id
              break;
            case "upi":
              transactionReference =
                "#" + transaction.gatewayResponse.acquirer_data.rrn || "N/A"; //rrn , upi_transaction_id
              break;
            case "card":
              transactionReference =
                "#" + transaction.gatewayResponse.acquirer_data.auth_code ||
                "N/A"; //auth_code
              break;
            default:
              transactionReference = "N/A";
          }
        } else {
          transactionReference = "N/A";
          paymentMode = "N/A";
        }
        return transactionReference;
      } else if (transaction && transaction.paymentGateway == "paytm") {
        return "#" + transaction.paymentDetails.orderId;
      }
    },
  },

  computed: {
    userDetails() {
      return this.$store.state.userDetails;
    },
  },
};
</script>

<style scoped>
/deep/.credit-points-history-tabs {
  height: 100%;
}

/deep/.credit-points-history-tabs .tab-content {
  height: calc(100% - 30px);
}
/deep/.credit-points-history-tabs .tab-space {
  padding: 0px;
  padding-top: 1em;
}

/deep/ .tab-content {
  height: calc(100% - 68px);
  position: relative;
}

.autocomplete-result {
  margin-top: 1em;
  padding-bottom: 1em;
  border-bottom: 1px solid #ebebeb;
  padding-right: 0;
  padding-left: 0;
}

.credit-request {
  height: calc(100% - 125px);
  overflow-y: scroll;
  overflow-x: hidden;
}

.content > div {
  height: 100%;
}

.credit-request {
  height: 100%;
  width: 100%;
}
.button-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  padding: 1em;
  width: 95%;
  border-top: 1px solid #ccc;
  left: 50%;
  transform: translateX(-50%);
  background: white;
}
</style>
